"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Button_1 = require("@material-ui/core/Button");
const Dialog_1 = require("@material-ui/core/Dialog");
const DialogActions_1 = require("@material-ui/core/DialogActions");
const DialogContent_1 = require("@material-ui/core/DialogContent");
const DialogContentText_1 = require("@material-ui/core/DialogContentText");
const DialogTitle_1 = require("@material-ui/core/DialogTitle");
function MessageDialog(props) {
    const open = !!props.open;
    const { title, message, mainButtonText, onMainButtonClick, secondaryButtonText, onSecondaryButtonClick, onClose, } = props;
    return (React.createElement("div", null,
        React.createElement(Dialog_1.default, { open: open, onClose: onClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
            title && React.createElement(DialogTitle_1.default, { id: "alert-dialog-title" }, title),
            React.createElement(DialogContent_1.default, null,
                React.createElement(DialogContentText_1.default, { id: "alert-dialog-description" }, message)),
            React.createElement(DialogActions_1.default, null,
                React.createElement(Button_1.default, { onClick: onMainButtonClick, color: "primary", autoFocus: true }, mainButtonText),
                secondaryButtonText && onSecondaryButtonClick && (React.createElement(Button_1.default, { onClick: onSecondaryButtonClick, color: "default" }, secondaryButtonText))))));
}
exports.default = MessageDialog;
//# sourceMappingURL=MessageDialog.js.map